// extracted by mini-css-extract-plugin
module.exports = {"nav":"Menu_nav__27BT9","navOpen":"Menu_navOpen__1b2Qp","menuNav":"Menu_menuNav__UKfPI","menuNavOpen":"Menu_menuNavOpen__7YrW_","menuNavItem":"Menu_menuNavItem__cjLyJ"};